export const spreadsheetTemplates = {
	users: "https://media.launchpad.com.br/VjjwN3yCLG8ttOpM/8dfa02e1-929b-448d-abee-6ace6d3ab089.xlsx",
	clients: "https://media.launchpad.com.br/VjjwN3yCLG8ttOpM/09baeb47-21af-4cc3-91f2-06508bc46aa6.xlsx",
	blocked_clients: "https://media.launchpad.com.br/VjjwN3yCLG8ttOpM/3de3dc03-65f8-4af2-bfca-189f6898e6f3.xlsx",
	solutions: "https://media.launchpad.com.br/VjjwN3yCLG8ttOpM/cb497eb2-625a-40d3-8636-33dcfd988451.xlsx",
};
